// Temporizadores en un Web Worker: el navegador no los congela tanto cuando la pestaña está en segundo plano.
let worker = null;
let seq = 0;
const cbs = new Map();

function getWorker() {
  if (worker) return worker;
  const src = "const t={};onmessage=(e)=>{const{id,ms,stop}=e.data;if(stop){clearInterval(t[id]);delete t[id];return;}t[id]=setInterval(()=>postMessage(id),ms);};";
  worker = new Worker(URL.createObjectURL(new Blob([src], { type: "text/javascript" })));
  worker.onmessage = (e) => { const fn = cbs.get(e.data); if (fn) fn(); };
  return worker;
}

export function bgInterval(fn, ms) {
  const id = ++seq;
  cbs.set(id, fn);
  try {
    getWorker().postMessage({ id, ms });
  } catch (e) {
    cbs.delete(id);
    const h = setInterval(fn, ms);
    return () => clearInterval(h);
  }
  return () => { cbs.delete(id); worker?.postMessage({ id, stop: true }); };
}

// Mantener un Web Lock evita que Chrome congele o descarte la pestaña (equipos que imprimen).
const locks = new Set();
export function keepTabAwake(name) {
  if (locks.has(name) || !navigator.locks?.request) return;
  locks.add(name);
  navigator.locks.request(name, () => new Promise(() => {})).catch(() => locks.delete(name));
}
